import React, { useEffect, useState } from 'react'
import { validateAmountNotification, validateAmountWaitedTime } from '../../../helpers/inputValidation'
import { typesValidation } from 'data/constants'
import { Button, Spinner } from 'react-bootstrap'

export default function FormAdministration({ value, setConfig, loading }) {
    const [amountNotification, setAmountNotification] = useState({ value: 0, estado: 0, helperText: '' })
    const [amountWaitedTime, setAmountWaitedTime] = useState({ value: 0, estado: 0, helperText: '' })

    useEffect(() => {
        if (value) {
            setAmountNotification((lastValue) => ({ ...lastValue, value: value.cantidad_notificaciones.valor }))
            setAmountWaitedTime((lastValue) => ({ ...lastValue, value: value.duracion_notificaciones.valor }))
        }
    }, [value])

    const validateInputs = () => {
        handleInputChange(setAmountNotification, amountNotification.value, typesValidation.AMOUNTNOTIFICATION)
        handleInputChange(setAmountWaitedTime, amountWaitedTime.value, typesValidation.AMOUNTWAITEDTIME)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        validateInputs()
        if (amountNotification.estado !== 1 || amountWaitedTime.estado !== 1) return
        const body = {
            cantidad_notificaciones: amountNotification.value,
            duracion_notificaciones: amountWaitedTime.value,
        }
        setConfig(body)
    }

    const handleInputChange = (set, value, type) => {
        const regex = /^[0-9]+$/
        const validationTypes = {
            amountNotification: () => validateAmountNotification(value),
            amountWaitedTime: () => validateAmountWaitedTime(value),
        }
        const { code, helperText } = validationTypes[type]()
        if (regex.test(value) || value === '') {
            set({ value: Number(value), estado: code, helperText })
        }
    }

    return (
        <div>
            <div className='administration'>
                <form>
                    <div className='card-configuration mb-5'>
                        <label className='form-label'>
                            <span className='fs-5 me-2'>Número de notificaciones</span>
                            <span className='span-msg'>(Min: 1, Max: 4)</span>
                        </label>
                        <input
                            type='text'
                            className={`admin-input ${amountNotification.estado === 2 ? 'border-validation-red' : ''}`}
                            id='cantidad_notificaciones'
                            name='cantidad_notificaciones'
                            value={amountNotification.value}
                            onChange={(e) =>
                                handleInputChange(
                                    setAmountNotification,
                                    e.target.value,
                                    typesValidation.AMOUNTNOTIFICATION,
                                )
                            }
                            placeholder='Ingrese número de notificaciones'
                            style={{ textAlign: 'center' }}
                            required
                        />
                        {amountNotification.estado === 2 && (
                            <p className='message-error'>{amountNotification.helperText}</p>
                        )}
                    </div>

                    <div className='d-flex flex-column card-configuration'>
                        <label className='form-label'>
                            <span className='fs-5 me-2'>Tiempo de duración de la Notificación</span>
                            <br/>
                            <span className='span-msg'>(Minutos) (Min: 2, Max: 6 )</span>
                        </label>
                        <input
                            type='text'
                            className={`admin-input ${amountWaitedTime.estado === 2 ? 'border-validation-red' : ''}`}
                            id='duracion_notificaciones'
                            name='duracion_notificaciones'
                            value={amountWaitedTime.value}
                            onChange={(e) =>
                                handleInputChange(setAmountWaitedTime, e.target.value, typesValidation.AMOUNTWAITEDTIME)
                            }
                            placeholder='Ingrese numero de notificaciones'
                            style={{ textAlign: 'center' }}
                            required
                        />
                        {amountWaitedTime.estado === 2 && (
                            <p className='message-error'>{amountWaitedTime.helperText}</p>
                        )}
                    </div>
                </form>
                <Button style={{ minWidth: '102px' }} variant='blue' className='mt-3' onClick={handleSubmit}>
                    {loading ? <Spinner variant='light' size='sm' /> : 'Establecer'}
                </Button>
            </div>
        </div>
    )
}
